//#region Imports

import { Component, Input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';

//#endregion

@Component({
  selector: 'l-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  imports: [
    NgClass,
    CommonModule
  ]
})
export class LayoutComponent {

  //#region Public Properties

  @Input()
  public fullscreen: boolean = false;

  @Input()
  public foreground: boolean = false;

  @Input()
  public showHeader: boolean = false;

  @Input()
  public version: string = '';

  //#endregion

}
